var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 25px;\n        fill: #27eac8;\n        text-anchor: middle;\n        font-family: Roboto;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "+",
    className: "cls-1",
    transform: "matrix(1.437, 1.434, -1.437, 1.434, -0.832, 23.066)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "+"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageFlower);
export default __webpack_public_path__ + "static/media/page-flower.7940c0b8a204437284d34daa79efe1c4.svg";
export { ForwardRef as ReactComponent };